import { Component, Injectable, EventEmitter} from "@angular/core";

@Injectable()
export class SharedService {
    photo = new EventEmitter<any>();
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/shared.service.ts